<script setup>
import { computed, ref, watchEffect  } from 'vue'
import Header from './components/ui/Header.vue'
import Navigation from './components/ui/Navigation.vue'
import Footer from './components/ui/Footer.vue'
import CustomModal from '@/components/BsCustomModal'
import { store } from './store/index.js'
import { sasEnviromentsViya4,  paAnnouncements } from '@/services/importingJsons.js'

import { useMsal } from '@/composition-api/useMsal.js'
const { instance } = useMsal()

const requestedEnvironmentChange = ref(undefined)
const requestedSASEnvironmentChange = ref(undefined)

const oidcIsAuthenticated = computed(() => store.getters['oidc/oidcIsAuthenticated'])

const adIsAuthenticated = () => {
  if(store.state.bearerToken !== null)return true 
  else return false
}

const userInfoMessage = computed(() => {
  return store.state.setGUIInfoMessage
})
const bannerTitleLink = computed(() => {
  return store.state.setGUIBannerTitleLink
})
const bannerLink = computed(() => {
  return store.state.setGUIBannerLink
})

const teamsLink = computed(() => {
  return store.state.setGUIteamsLink
})
const userWarningMessage = computed(() => {
  return store.state.setGUIWarningMessage
})

const handleEnvironmentSwitchModalEvent = (event) => {
      if (event) {
        store.commit('setSelectedEnvironment', event)
        store.dispatch('population/reset')
      }
      requestedEnvironmentChange.value = undefined
    }

  const handleSASEnvironmentSwitchModalEvent = (event) => {
    if (event) {
      store.commit('setSelectedSASEnvironment', event)
      store.dispatch('population/reset')
    }
      //Logout
    store.dispatch('oidc/signOutOidcSilent', true)
    instance.logoutPopup({
    mainWindowRedirectUri: "/"
    })
    requestedSASEnvironmentChange.value = undefined
}

watchEffect(() => {
  if (!store.state.selectedEnvironment && adIsAuthenticated()) {
    store.commit('setEnvironmentsStatus', { loading: true, error: false })
    paAnnouncements().then(result => {
      var announcementObject = null
      if(window.location.origin.includes('localhost') || window.location.origin.includes('productanalytics.dm.csawsdev.net')){
        announcementObject = result?.productAnalyticsDevAnnouncements
      }else{
        announcementObject = result?.productAnalyticsAnnouncements
      }
      if (announcementObject?.bannerInfoMessage) {
          store.commit('setGUIInfoMessage', announcementObject.bannerInfoMessage)
        }
        if (announcementObject?.teamsUserCommunityMeetingLink) {
          store.commit('setGUIteamsLink', announcementObject.teamsUserCommunityMeetingLink)
        }
        if (announcementObject?.bannerWarningMessage) {
          store.commit('setGUIWarningMessage', announcementObject.bannerWarningMessage)
        }
        if (announcementObject?.link) {
          store.commit('setGUIBannerLink', announcementObject.link)
        }
        if (announcementObject?.linkTitle) {
          store.commit('setGUIBannerTitleLink', announcementObject.linkTitle)
        }
    }).finally(() => {
    })
    sasEnviromentsViya4().then(result => {

      var sasEnviromentsTemp = []
      for (var i = 0, l = result?.sasEnvironments.length; i < l; i++) {
          var obj = result?.sasEnvironments[i].groupAccess
          var obj1 = result?.sasEnvironments[i]
          for (var j = 0, k = obj.length; j < k; j++) {
            if(obj[j] === (store.state.isRnDAdvancedAnalysisPlatform ? 'RnDAdvancedAnalysisPlatform' : 'N')
            || obj[j] === (store.state.isODP_unlimited ? 'ODP_unlimited' : 'N')
            || obj[j] === (store.state.isODP_limited ? 'ODP_limited' : 'N')
            || obj[j] === (store.state.isYQI_Users ? 'YQI_Users' : 'N')
            || obj[j] === (store.state.isGUIUsersTst ? 'GUIUsersTst' : 'N')){
              sasEnviromentsTemp.push(obj1)
              break
            }
          }        
      }
      store.commit('setAvailableEnvironments', sasEnviromentsTemp)
      store.commit('setSelectedEnvironment',  sasEnviromentsTemp[0])
      store.commit('setSelectedSASEnvironment', (localStorage.getItem('selectedSASEnvDesc') === 'SNAPROD' || localStorage.getItem('selectedSASEnvDesc') === null ) ? 
      {"description":"SNAPROD","url":"https://snaprod.ondemand.sas.com"} : 
      {"description":"SNATEST","url":"https://snatest.ondemand.sas.com"})
      store.commit('setEnvironmentsStatus', { loading: false, error: false })

    }).catch(e => {
      console.log('Error loading enviroments:' + e)
    })
  } 
})
  
</script>

<template>
  <div id="App">
    <body>
      <c-theme
        name="scania"
        global="true"
      />
      <Header />
      <Navigation
        @environment-change="requestedEnvironmentChange = $event"
        @environment-sas-change="requestedSASEnvironmentChange = $event"
      />
      <custom-modal
        v-if="requestedEnvironmentChange"
        id="environmentSwitchModal"
        title="Switching environment"
        body-text="If the environment is switched, all current selections will be reset. Do you want to proceed?"
        :pass-through="requestedEnvironmentChange"
        @click="handleEnvironmentSwitchModalEvent($event)"
      />
      <custom-modal
        v-if="requestedSASEnvironmentChange"
        id="environmentSASSwitchModal"
        title="Switching SAS environment"
        body-text="If the environment is switched, all current selections will be reset. Do you want to proceed?"
        :pass-through="requestedSASEnvironmentChange"
        @click="handleSASEnvironmentSwitchModalEvent($event)"
      />
      <div>
        <div
          v-if="oidcIsAuthenticated && userInfoMessage !== '' && teamsLink !== ''"
          slot="secondary-items"
          class="alert alert-info"
          role="alert"
        >
          <h5>
            <c-icon name="scania-information" />
            {{ userInfoMessage }}
          </h5>
        </div>
        <div
          v-if="oidcIsAuthenticated && userInfoMessage !== ''"
          slot="secondary-items"
          class="alert alert-info"
          role="alert"
        >
          <h5>
            <c-icon name="scania-information" />
            {{ userInfoMessage }}
            <a v-if="teamsLink !== ''"
              slot="items"
              :href="teamsLink"
              target="_blank"
            >Click here to join</a>
            <a v-if="bannerLink !== '' && bannerTitleLink !== ''"
              slot="items"
              :href="bannerLink"
              target="_blank"
            >{{bannerTitleLink}}</a>
          </h5>
        </div>
        <div
          v-if="userWarningMessage !== ''"
          slot="secondary-items"
          class="alert alert-warning"
          role="alert"
        >
          <h5>
            <c-icon name="scania-warning" />
            {{ userWarningMessage }}
            <a v-if="bannerLink !== '' && bannerTitleLink !== ''"
              slot="items"
              :href="bannerLink"
              target="_blank"
            >{{bannerTitleLink}}</a>
          </h5>
        </div>
      </div>
      <c-content>
        <router-view /> 
      </c-content>
  </body>
  </div>
  <Footer />
</template>


<style>

.alert{
  margin-bottom: 0;
}
h5 {
  margin-top: 0.95rem;
}
html, body {
  height: 100%;
  margin: 0;
  display: flex;
  flex-direction: column;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh; /* Full viewport height */
}
.c-content {
  flex: 1; /* Pushes footer to the bottom */
  padding-bottom: 60px; /* Space for footer to avoid overlap */
}

</style>
